<template>
  <div class="socket-text-content">
    <div v-if="!connected">Connecting...</div>
    <div v-else>
      <p
        class="ma-0 pa-0"
        v-for="(message, index) in displayMessages"
        :key="index"
      >
        {{ message }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    displayMessages: {
      type: Array,
      default: () => [],
    },
    connected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped></style>
